export const inview = () => {
  const fadeIn = (target: HTMLElement) => target.classList.add('_inview');

  const executeInview = () => {
    const elements = document.querySelectorAll<HTMLElement>(
      '.js-inview:not(._withLoad):not(._inview)',
    );
    const inviewElement = (entries: IntersectionObserverEntry[]) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          fadeIn(entry.target as HTMLElement);
          // eslint-disable-next-line @typescript-eslint/no-use-before-define
          io.unobserve(entry.target);
        }
      });
    };
    const io = new IntersectionObserver(inviewElement, {
      rootMargin: '-10% 0px',
    });

    elements.forEach((el) => {
      io.observe(el);
    });
  };

  const inviewWithLoad = () => {
    const elements = document.querySelectorAll<HTMLElement>('.js-inview._withLoad:not(._inview)');
    elements.forEach((el, index) => {
      setTimeout(() => {
        fadeIn(el);
      }, index * 300 + 300);
    });
  };

  const changeDom = () => {
    executeInview();
  };
  const mo = new MutationObserver(changeDom);

  mo.observe(document, {
    subtree: true,
    childList: true,
  });

  executeInview();
  inviewWithLoad();
};
